import config from "@Config/index";

/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
const uetEventEmitter = ({ action, category, label, value }: any) => {
  // @ts-ignore
  if (typeof uetq !== "undefined" && action) {
    // @ts-ignore
    window.uetq = window.uetq || [];
    // @ts-ignore
    window.uetq.push("event", action, {
      event_category: category,
      ...(label && { event_label: label }),
      ...(value && { event_value: value }),
    });
  }
};

export default uetEventEmitter;

export const uetEventEmitterForChina = ({ leadEmail, leadPhoneNumber }: any) => {
  if (config.IS_CHINA_APP) {
    // @ts-ignore
    if (typeof uetq !== "undefined") {
      // @ts-ignore
      window.uetq = window.uetq || [];
      // @ts-ignore
      window.uetq.push("set", {
        pid: {
          em: leadEmail,
          ph: leadPhoneNumber,
        },
      });
    }
  }
};
